import React, {useState} from "react";
import WeatherInfo from './WeatherInfo';
import Forecast from './Forecast';

import axios from "axios";

export default function Weather(props) {
const [weatherData, setWeatherData] = useState({ready: false});
const [city, setCity] = useState(props.defaultCity);

function handleResponse(response) {
setWeatherData({
  ready: true,
  city: response.data.name,
  date: new Date(response.data.dt*1000),
  temperature: response.data.main.temp,
  description: response.data.weather[0].description,
  humidity: response.data.main.humidity,
  wind: response.data.wind.speed,
  icon: response.data.weather[0].icon
});
}
function search(){
    const apiKey = "5b0bfa960cf8480fafd9ea6aed867930";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
}
function handleSubmit(event) {
event.preventDefault();
search();
}
function changeChity(event){
setCity(event.target.value);
}
function searchLocation(position) {
  let apiKey = "5b0bfa960cf8480fafd9ea6aed867930";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=${apiKey}&units=metric`;
  axios.get(apiUrl).then(handleResponse);
 }

 function getCurrentLocation(event) {
 event.preventDefault();
 navigator.geolocation.getCurrentPosition(searchLocation);
 }
if (weatherData.ready) {
    return (
    <div>
    <form id="search-form" onSubmit={handleSubmit}>
    <div class="row">
      <div class="col-9">
        <input
          type="search"
          placeholder="Enter your city here"
          id="city-input"
          autocomplete="off"
          onChange={changeChity}
        />
        <input 
        type="submit" 
        value="Search" 
        id="search-button"
        />
        
      </div>
      <div class="col-3">
        <button id="current-location" onClick={getCurrentLocation}>My location</button>
      </div>
    </div>
  </form>
  <WeatherInfo data={weatherData}/>
  <Forecast city={weatherData.city}/> 
</div>)
}else {
    search();
return "Loading..."
    }
  }
  